import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  Button,
  Form,
  Statistic,
  Select
} from 'antd';
import { CaretDownOutlined } from '@ant-design/icons';

import Box from '../../components/Box';
import { open } from '../../layout/components/Drawer/Drawer.reducer';
import { setSelected } from '../Construction/construction.reducer';
import selector from './ConstructionFooter.selector';

import {
  Container,
  InfoBox,
  Spacer,
  Col,
  BoxContent,
  TransportWrapper,
  StatisticsWrapper
} from './ConstructionFooter.styles';
import { colors } from '../../utils/variables.styles';
import { useTranslation } from '../../contexts/TranslationContext';
import { DISPLAY_CURRENCY } from '../../config';

const { Option } = Select;

function ConstructionHeader({
  openForm,
  parameters_loaded = false,
  voivodeship = [],
  price = 0,
  transport = 0,
  handleSelect,
  isSticky = false
}) {
  const [form] = Form.useForm();
  const translationsData = useTranslation();

  const handleSubmit = () => {
    form.validateFields()
      .then(() => {
        openForm('buy');
      })
      .catch(() => {});
  };

  const handleSelectChange = (value) => {
    form.setFieldsValue({ voivodeship: value });
    handleSelect('voivodeship', value);
  };

  return (
    <Form form={form} layout="vertical" onFinish={handleSubmit}>
      <Container>
        <Spacer />
        <Col grid={4}>
          <Box
            id="select-container"
            clear
            loading={!parameters_loaded}
            loaderHeight={99}
            styles={{ background: colors.main, color: colors.primaryFontColor }}
          >
            <BoxContent>
              <Form.Item
                name="voivodeship"
                label={translationsData.voivodeship || 'voivodeship'}
                rules={[{
                  required: true,
                  message: translationsData.please_select_voivodeship || 'please_select_voivodeship'
                }]}
                className="select-up"
              >
                <Select

                  getPopupContainer={() => document.getElementById('select-container')}
                  suffixIcon={<CaretDownOutlined fill={colors.selectArrow} className="custom-chevron" />}
                  onChange={handleSelectChange}
                  placeholder={translationsData.please_select_voivodeship || 'please_select_voivodeship'}
                >
                  {voivodeship.map((el) => (
                    <Option key={el.id} value={el.id}>
                      {el.attributes.name.charAt(0).toUpperCase() + el.attributes.name.slice(1).toLowerCase()}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </BoxContent>
          </Box>
        </Col>
        <Col grid={4}>
          <Box
            clear
            loading={price === null}
            loaderHeight={99}
            wide
            styles={{ background: colors.white }}
          >
            <StatisticsWrapper>
              <Statistic
                title={translationsData.brutto_price || 'brutto_price'}
                value={price + transport}
                groupSeparator="."
                suffix={DISPLAY_CURRENCY}
              />
              <TransportWrapper>
                {translationsData.entire_cost_with_transport || 'entire_cost_with_transport'}
              </TransportWrapper>
            </StatisticsWrapper>
          </Box>
        </Col>
        <Col grid={2}>
          <Button
            htmlType="submit"
            type="primary"
            loading={!parameters_loaded}
            style={{ width: '100%', height: 99, fontSize: 24 }}
          >
            {translationsData.buy_now || 'buy_now'}
          </Button>
        </Col>
      </Container>
      <InfoBox>
        * {translationsData.all_orders || 'all_orders'}
        <br />
        {translationsData.additional_information_2 || 'additional_information_2'}
      </InfoBox>
    </Form>
  );
}

ConstructionHeader.propTypes = {
  handleSelect: PropTypes.func.isRequired,
  openForm: PropTypes.func.isRequired,
  isSticky: PropTypes.bool,
  parameters_loaded: PropTypes.bool,
  price: PropTypes.number,
  transport: PropTypes.number,
  voivodeship: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      attributes: PropTypes.shape({
        name: PropTypes.string
      }).isRequired
    })
  )
};


const mapDispatchToProps = {
  openForm: open,
  handleSelect: setSelected
};

export default connect(selector, mapDispatchToProps)(ConstructionHeader);
